// istanbul ignore file
/**
 * Loader for components/meetings used by getAnalyticsOrNoop.
 * Extracted so tests can mock it to throw and cover the catch branch.
 */
export function loadMeetingsModule() {
  return import('components/meetings')
}
